module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Thin-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Thin-webfont.woff
// module id = 1622
// module chunks = 0